import React from 'react'
import './TableFooter.scss'
import {FiArrowRight,FiArrowLeft} from 'react-icons/fi' 


const TableFooter = ({metadata,setPageNumber,pageNumber}) => {
 
const prev = ()=>{
if(metadata?.hasPrevious){
  setPageNumber(pageNumber-1)
}
}
const next = ()=>{
  if(metadata?.hasNext){
    setPageNumber(pageNumber+1)
  }
}
  if(!!metadata){
  return (
    <div className='footer'>
      <div style={{color:'grey',marginLeft:'20px'}}> {metadata?.currentPage} of {metadata?.totalPages}</div>
      <div className='footer_right'>
        <div className='footer_right_row'>Rows per page {metadata?.pageSize}  </div>
        <div className='arrows'>
          <div onClick={()=>prev()}   className={metadata?.hasPrevious ? 'arrows_left': 'arrows_left arrows_left_disabled'}><FiArrowLeft /></div>
          <div onClick={()=>next()} className={metadata?.hasNext ? 'arrows_left': 'arrows_left arrows_left_disabled'}><FiArrowRight /></div>
        </div>
      </div>
    </div>
  )}
  return(<></>)
}

export default TableFooter